import React from "react";
import { FaMapMarkerAlt, FaPercent, FaStar, FaHandsHelping } from "react-icons/fa";
import "../Why/Why.css";

const Why = () => {
  const items = [
    { icon: <FaMapMarkerAlt />, text: "Tailored Travel Plans" },
    { icon: <FaPercent />, text: "Best Price Promise" },
    { icon: <FaStar />, text: "Top-Rated Excellence" },
    { icon: <FaHandsHelping />, text: "Trusted Expertise" },
];


  return (
    <section className="why-book">
      <h2 className="why-title">WHY BOOK WITH US</h2>
      <div className="why-list">
        {items.map((item, index) => (
          <div className="why-item" key={index}>
            <div className="why-icon">{item.icon}</div>
            <p className="why-text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Why;
